const APIS = {
  PAYMENT_METHOD: 'logisticservice/api/payment-method/',
  BRANCH: '/usermanagementservice/api/branch/',
  LOCATION: 'logisticservice/api/location/',
  STAFF: 'usermanagementservice/api/user/',
  GRID_REPORT_DATA: '/projectsettingsservice/api/courier-grid-report/',
  REMARK: '/logisticservice/api/remark/',
  USER: '/usermanagementservice/api/user/',
  RUNSHEET: '/runsheetservice/api/runsheet/',
  RECEIVER_DETAIL: '/logisticservice/api/receiver-detail/',
  STATUS: 'logisticservice/api/status/',
  COMMENT: '/commentservice/api/comment/',
  STATUS_NEXT: '/logisticservice/api/status/next-status/',
  RUNSHEET_SETTING: '/runsheetservice/api/runsheet-settings/',
  INVOICE: '/invoiceservice/api/merchant-invoice/invoice-id/',
  RIDER: 'fleetservice/api/driver/',
  ORDER_HISTORY: '/historyservice/api/history/',
  CUSTOMER: '/logisticservice/api/customer/',
  MERCHANT: 'logisticservice/api/merchant/',
  ORDER: '/logisticservice/api/order/',
  CLIENT_TYPE: '/logisticservice/api/client-type/',
  CACHE: '/cacheservice/api/invalidate-cache/',
};

export default APIS;
